module.exports = __webpack_public_path__ + "svg/roulette-timer-mobile.svg?c9f21920041b16c7d5546d6c7519d98a";